
<div class="row">
  <div class="col-md-8">
    <div class="col-lg-12 nopadding">
      <app-filter-panel [GridColumns]="GridColumns" [DefaultFilterArray]="defaultFilterArray"
        (FilterEvent)="filterApplyFilterEvent($event)">
      </app-filter-panel>
    </div>
    
    <div class="col-lg-12 nopadding">
      @if(isLoadingResults){
      <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
      </div>
      }
      <p-table #dt 
        [value]="dataset" 
        [columns]="cols" 
        [resizableColumns]="true" 
        [lazy]="true"    
        (onPage)="changePage($event)" 
        [sortOrder]="constantService.DEFAULT_SORDORDER_ASC" 
        [(selection)]="selectedRow"
        (onRowSelect)="onRowSelect(selectedRow)"
        [paginator]="true" 
        selectionMode="single"
        appendTo="body" 
        alwaysShowPaginator="true" 
        paginatorPosition="both"
        showCurrentPageReport="true" 
        [rows]="constantService.DEFAULT_ROWSIZE" 
        [totalRecords]="totalRecords"
        [pageLinks]="constantService.DEFAULT_PAGELINKS" 
        sortMode="multiple"
        [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION"
        [scrollable]="true" 
        scrollHeight="70vh"
        styleClass="tableData">
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{constantService.NO_RECORDFOUND_MSG}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns let-rowIndex=rowIndex>
          <tr>
            @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
            <th id="colHeader" pResizableColumn [pSortableColumn]="col.field"
              [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
              {{col.header}}
            </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" class="ui-widget-NoUpdated-row">
            @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
            <td class="ui-resizable-column"
              [ngClass]="(col.header | lowercase) =='order count' ||(col.header | lowercase) == 'mtd avg' || 
              (col.header | lowercase) == '30 dma' || (col.header | lowercase) =='account code' || (col.header | lowercase) =='rsms act code'
              ?  getBgColor(col.header,row[col.field]) ? [tblColBgColor]  : [tblColBgColor] :  ''">
              @if(col.header==='action'){
              <span>
                <p-button [style]="{'width': '20px'}" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View"
                [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-eye" [id]="'view'+ rowIndex"
                  (click)="openDialog(row)"></p-button>
              </span>
              }
              <!-- set String -->
                <span [ngClass]="col.datatype === 'Int'? 'float-right' :''">
                  {{row[col.field] !== 'null' ? row[col.field]: ""}}
                </span>
            </td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorright">
            <app-export-to-csv [gridColumns]="GridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
          Total Records: {{dataset.length == 0? 0 : totalRecords}}
    
        </ng-template>
        <ng-template pTemplate="paginatorleft">
          <!-- Page No : {{pageNumber }} -->
          Showing {{dataset.length == 0? 0 : startLimit + 1}} to {{dataset.length
             < rowcount ? dataset.length < startLimit ? endLimit : dataset.length : endLimit}} entries
        </ng-template>
      </p-table>
    </div>
  </div>
  @if(isShowGraph){
  <div class="col-md-4">
    <app-option-origin-code-graph 
    [selectedRow]="selectedRow"
    (closeDialog)="isShowGraph=false"
    ></app-option-origin-code-graph>
  </div>
  }
</div>
@if(isShowCMTADetails){
<app-ooc-cmta-details [selectedRow]="selectedRow" (closeDialog)="isShowCMTADetails = false"></app-ooc-cmta-details>
}